import PostApi from '../includes/logic/Api/PostApi'
import { BonusHistoryRequest, BonusHistoryRequestType } from '../includes/types/BonusHistory'
import { BonusInfo } from '../includes/types/BonusInfo'

export default class BonusApi {
  static async getBonusInfo(): Promise<{ data:BonusInfo }> {
    return PostApi.sendRequest('tg', 'getbonusinfo')
  }

  static async getBonusHistory<T>(reqBody: BonusHistoryRequest){
    return PostApi.sendRequest<BonusHistoryRequestType<T>, BonusHistoryRequest>('tg', 'getbonushistory', { ...reqBody })
  }
}
